import { useEffect } from "react";
import { useLocation } from "react-router";

const APP_NAME = "VCG CRM";

function formatSegment(segment: string): string {
	return segment
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

function getTitle(pathname: string): string {
	if (pathname === "/") return `Home | ${APP_NAME}`;

	const segments = pathname.split("/").filter(Boolean);

	// Filter out numeric IDs and build readable parts from what remains
	const parts = segments.filter((s) => !/^\d+$/.test(s)).map(formatSegment);

	if (parts.length === 0) return APP_NAME;

	// Show most specific segment first: "/reports/billing" → "Billing - Reports"
	const title = parts.reverse().join(" - ");
	return `${title} | ${APP_NAME}`;
}

export function DocumentTitle() {
	const { pathname } = useLocation();

	useEffect(() => {
		document.title = getTitle(pathname);
	}, [pathname]);

	return null;
}
